@use 'themes/westfield' as *;
@use 'tools/dirg' as *;
@use 'tools/color' as *;
@use 'tools/if-theme' as *;
@use 'tools/dirg-breakpoint' as *;
@use 'tools/typography.module' as *;

$primary-border-width: 2px;

.Spinner {
  width: units(1.5) !important;
  height: units(1.5) !important;

  path {
    fill: color('Black');

    @include if-theme('scentregroup') {
      fill: color('Charcoal');
    }
  }
}

.Button {
  @extend .heading;
  font-size: font-scale(1);
  line-height: font-scale(2);
  height: units(3);
  cursor: pointer;
  text-transform: uppercase;

  &[disabled] {
    cursor: not-allowed;
  }

  .text {
    display: inline-flex;
    align-items: center;
  }
}

.FilledButton {
  composes: Button;
  padding: 0 units(1);
  border-radius: 1px;
  min-width: columns(2) + units(2);

  @include if-theme('scentregroup') {
    border-radius: 3px;
  }
}

.ButtonPrimary {
  composes: FilledButton;
  color: color('White');
  background: color('Black');

  @include if-theme('scentregroup') {
    background: color('Charcoal');
  }

  &:hover {
    background: color('Black', -2);

    @include if-theme('scentregroup') {
      background: color('Charcoal', -2);
    }
  }

  &:active {
    background: color('Black', 4);

    @include if-theme('scentregroup') {
      background: color('Charcoal', 4);
    }
  }
}

.ButtonPrimaryDisabled {
  composes: ButtonPrimary;
  background: color('Grey');

  &:active,
  &:hover {
    background: color('Grey');
  }
}

.ButtonSecondary {
  composes: FilledButton;
  color: color('White');
  border: 0;
  background: color('Grey');

  @include if-theme('scentregroup') {
    color: color('Charcoal');
    background: transparent;
    border: 2px solid;
  }

  &:hover {
    color: color('White');
    background: color('Grey', -2);

    @include if-theme('scentregroup') {
      color: color('Charcoal', -2);
      background: transparent;
    }
  }

  &:active {
    color: color('White');
    background: color('Grey', 4);

    @include if-theme('scentregroup') {
      color: color('Charcoal');
      background: rgba(color('Charcoal'), 0.2);
    }
  }
}

.ButtonSecondaryLight {
  composes: ButtonSecondary;
  color: color('White');

  &:hover {
    color: color('White');
    background: color('Grey', -2);

    @include if-theme('scentregroup') {
      background: rgba(color('Grey'), 0.2);
    }
  }

  &:active {
    color: color('White');
    background: color('Grey', 4);

    @include if-theme('scentregroup') {
      background: rgba(color('Charcoal'), 0.7);
    }
  }
}

.ButtonSecondaryDisabled {
  composes: ButtonSecondary;
  color: color('Grey');

  &:active,
  &:hover {
    color: color('Grey');
    background: color('Grey');

    @include if-theme('scentregroup') {
      background: transparent;
    }
  }
}

.ButtonSecondaryLightDisabled {
  composes: ButtonSecondaryDisabled;

  .Spinner path {
    fill: color('Grey');
  }
}

.ButtonTertiary {
  composes: Button;

  @extend .bodyFont;
  background: transparent;
  text-transform: initial;
  font-size: font-scale(1);
  color: color('Black');

  @include if-theme('scentregroup') {
    color: color('Charcoal');
    font-size: font-scale(2);
  }

  .text {
    box-shadow:
      0 1px 0 currentColor,
      0 2px 0 currentColor;
  }

  &:hover {
    color: color('Black', -5);

    @include if-theme('scentregroup') {
      color: color('Charcoal', -5);
    }
  }

  &:active {
    color: color('Black');
  }
}

.ButtonTertiaryLight {
  composes: ButtonTertiary;
  color: color('White');

  &:active {
    color: color('White');
  }
}

.ButtonTertiaryDisabled {
  composes: ButtonTertiary;
  color: color('Grey');

  &:active,
  &:hover {
    color: color('Grey');
  }

  .Spinner path {
    fill: color('Grey');
  }
}

.ButtonTertiaryLightDisabled {
  composes: ButtonTertiaryDisabled;
}

.ButtonInferior {
  composes: Button;

  @extend .bodyFont;
  background: transparent;
  text-transform: uppercase;
  font-size: font-scale(1);
  color: color('Black');
  border: 2px solid color('Black');

  @include if-theme('scentregroup') {
    color: color('Charcoal');
    font-size: font-scale(2);
  }

  &:hover {
    color: color('Black', -5);

    @include if-theme('scentregroup') {
      color: color('Charcoal', -5);
    }
  }

  &:active {
    color: color('Black');
  }
}

.ButtonInferiorDisabled {
  composes: ButtonTertiary;
  color: color('Grey Dark');
  border: 2px solid color('Grey Dark');

  &:active,
  &:hover {
    color: color('Grey');
  }

  .Spinner path {
    fill: color('Grey Dark');
  }
}
